import { useMemo } from 'react';
import { Store } from '../../../store';
import { myEventsCutoff } from '../my-events-cutoff';
import type { UseEventsHook } from './use-events';
import { useEvents } from './use-events';

/*
 * "My Events": events (live + upcoming) linked to a validator via verifier_email.
 * Bounded to the operational window: end_time_gte drops already-ended events and
 * start_time_lte caps at the next 4 AM. No status filter, so both live and upcoming
 * come back. Defaults to the logged-in user's email, or the validator picked in the
 * toolbar (filters.verifierEmail).
 *
 * No onUpdate handler on purpose: the previous `evictEventsFromCache` on every
 * subscription update made events blink out (evict) then back (the websocket
 * refetches them), which is the scroll/loading flicker. The websocket already
 * refetches updated events in place and drops any that left the filter.
 */
export const useMyEvents: UseEventsHook = (filters) => {
  const { me } = Store.User.useIdentity();

  const pastEventCutoff = useMemo(() => new Date(Date.now() - 30 * 60 * 1000).toISOString(), []);
  const upcomingCutoff = useMemo(() => myEventsCutoff().toISO(), []);

  return useEvents(filters, {
    end_time_gte: pastEventCutoff,
    start_time_lte: upcomingCutoff,
    verifier_email: filters.verifierEmail ?? me?.email
  });
};
